import { useEffect } from "react";
import { useGeolocationStore } from "@/common/store/geolocationStore";
import { apiMain } from "@/common/services";

export const useDetectGeolocation = () => {
  const setLocation = useGeolocationStore((state) => state.setLocation);

  useEffect(() => {
    (async () => {
      const location = await apiMain.getGeolocation();

      setLocation(location);
    })();
  }, []);
};
